
define('text!modules/targeting/siteList/templates/bin_title.html',[],function () { return '<div class="header-c title site-list-title">\n\t<span class="label" data-bind="bin_label">Applied Site Lists</span>\n</div>';});

